<div class="text-input-container" [ngClass]="{'has-errors': hasErrors}">
    <boi-validation-error-generic (errorChange)="onErrorChange($event)" [validationErrors]="validationErrors"
        [propertyNames]="validationPropertyNames">
    </boi-validation-error-generic>

    <kendo-textbox-container>
        <div [ngClass]="cssClasses" class="field-container">
            <div class="field-label" [boiRequiredFormField]="required ? labelName : undefined"
                [forceRequired]="forceRequired">
                <div class="label-content">
                    <label
                        [for]="controlId ? controlId : labelName">{{inputLabel ? inputLabel: (labelName | localizeLabel)}}</label>
                    <ng-content></ng-content>
                </div>
                <boi-tooltip *ngIf="showTooltip && !isTooltipLast"
                    [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
            </div>
            <div class="field-input">
                <input #htmlInput [id]="controlId ? controlId : labelName" [type]="type"  [(ngModel)]="value"
                    [pattern]="pattern" [autocomplete]="autocomplete ? autocomplete : 'off'" [maxlength]="maxLength"
                    [readonly]="isReadonly" [disabled]="isFieldDisabled" [required]="required" kendoTextBox
                    (ngModelChange)="onValueChange($event)" (blur)="ensureTrimmedValue();onBlur()" [placeholder]="placeholder" [boiOnlyDigits]="digitsOnly"
                    [disablePeriod]="disablePeriod" [email]="type==='email'"  autocapitalize="off" />
                <span *ngIf="canShowPassword" class="password-eye" (click)="toggleShowPassword()"
                    [ngClass]="{'password-eye-closed': type === 'password', 'password-eye-opened': type === 'text'}"></span>
                <boi-tooltip *ngIf="showTooltip && isTooltipLast" [tooltipName]="tooltipName ? tooltipName : labelName">
                </boi-tooltip>
            </div>
        </div>
    </kendo-textbox-container>
</div>
